export default "__VITE_ASSET__w11ERlyc__ 660w, __VITE_ASSET__Cuu1sRAB__ 375w";